import app from 'app';

function FileUploaderInput(
  $q,
  SubmitClaimBillUploadConstants,
  SubmitClaimBillUploadService
) {
  return {
    restrict: 'A',
    scope: {
      fileUploaderInput: '=',
      accept: '@',
      maxFiles: '<',
      maxFileSize: '<',
      showMaxFilesError: '=',
    },
    link: (scope, element) => {
      scope.fileUploaderInput = scope.fileUploaderInput || [];

      function getRegExForFileTypes(fileTypes) {
        // change commas to |
        fileTypes = fileTypes.replace(/,/g, '|');
        // remove periods
        fileTypes = fileTypes.replace(/\./g, '');
        // remove spaces
        fileTypes = fileTypes.replace(/\s+/g, '');

        return `.(${fileTypes})`;
      }

      const fileRegEx = new RegExp(getRegExForFileTypes(scope.accept), 'i');

      function parseFile(file) {
        return {
          file,
          name: file.name,
          size: file.size,
        };
      }

      function getFilesArray(fileList) {
        const files = [];

        for (let i = 0; i < fileList.length; i++) {
          files.push(parseFile(fileList[i]));
        }

        return files;
      }

      function upload(files) {
        files.forEach((file) => {
          if (!fileRegEx.test(file.name)) {
            file.status = SubmitClaimBillUploadConstants.status.WRONG_TYPE;
          } else if (file.size > scope.maxFileSize) {
            file.status = SubmitClaimBillUploadConstants.status.TOO_BIG;
          } else {
            SubmitClaimBillUploadService.uploadFile(file);
          }
        });
      }

      element.bind('change', (changeEvent) => {
        scope.$apply(() => {
          const newFiles = getFilesArray(changeEvent.target.files);
          changeEvent.target.form.reset();
          const oldAndNew = scope.fileUploaderInput.concat(newFiles);

          scope.showMaxFilesError = oldAndNew.length > scope.maxFiles;

          if (!scope.showMaxFilesError) {
            scope.fileUploaderInput = oldAndNew;
            upload(newFiles);
          }
        });
      });
    },
  };
}

app.directive('fileUploaderInput', FileUploaderInput);

export default 'fileUploaderInput';
